/**
 * A list of brand codes that are internal brands and have their own theme
 */
export const INTERNAL_BRANDS_WITH_THEME = ['vio', 'goseek', 'dealbase'] as const

/**
 * A list of brand codes that are internal brands but don't have their own theme
 */
export const INTERNAL_BRANDS_WITHOUT_THEME = ['etrip', 'findhotel'] as const

/**
 * A list of brand codes that are affiliate brands and have their own theme
 */
export const EXTERNAL_BRANDS_WITH_THEME = [
  'bookaway',
  'checkmybus',
  'holidaypiratesde',
  'kayak',
  'kiwi',
  'ovago',
  'weward'
] as const

/**
 * A list of brand codes that are demo brands
 */
export const DEMO_BRANDS = [
  'demo',
  'demoAdvanced',
  'demoBasic',
  'demoCustom'
] as const

/**
 * Represents all possible brand codes in the system.
 * Used to identify different brands and their configurations.
 */
export const brandCodes = [
  ...INTERNAL_BRANDS_WITH_THEME,
  ...INTERNAL_BRANDS_WITHOUT_THEME,
  ...EXTERNAL_BRANDS_WITH_THEME,
  ...DEMO_BRANDS
] as const
